<template>
  <el-dialog 
    title="客户二维码" 
    :visible="visible"
    width="400px"
    :close-on-click-modal="false"
    @close="closeDialog()"
    center
  >
    <div class="qr-dialog-content">
      <div class="qr-header">
        <div class="customer-info">
          <el-avatar :size="40" :src="defaultAvatar" />
          <div>
            <h4>{{ customer.name }}</h4>
            <p>ID: {{ customer.id }}</p>
            <p v-if="customer.qrCodeExpireAt">
              有效期至: {{ formatDate(customer.qrCodeExpireAt) }}
            </p>
            <p v-if="isQrCodeExpired" style="color: #F56C6C;">
              <i class="el-icon-warning"></i> 二维码已过期
            </p>
          </div>
        </div>
      </div>
      
      <div class="qr-code-container">
        <div v-if="customer.qrCodePath" class="qr-code-image">
          <el-image 
            :src="customer.qrCodePath" 
            fit="contain"
            style="width: 250px; height: 250px;"
          >
            <div slot="error" class="image-error">
              <i class="el-icon-picture"></i>
              <div>二维码加载失败</div>
            </div>
            <div v-if="isQrCodeExpired" slot="placeholder" class="qr-expired-overlay">
              <div class="expired-text">二维码已过期</div>
            </div>
          </el-image>
        </div>
        <div v-else class="qr-code-placeholder">
          <i class="el-icon-picture" style="font-size: 120px; color: #409EFF;"></i>
          <div class="qr-text">客户专属二维码</div>
        </div>
      </div>
      
      <div class="qr-footer">
        <p>扫描二维码查看客户信息</p>
        <div class="qr-actions">
          <el-button 
            icon="el-icon-download" 
            type="primary" 
            plain
            @click="downloadQrCode"
            :disabled="!customer.qrCodePath"
          >
            下载二维码
          </el-button>
          <el-button 
            icon="el-icon-refresh" 
            type="info" 
            plain
            @click="refreshQrCode"
          >
            重新生成
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import defaultAvatar from '@/assets/default_user.png'

export default {
  name: 'QrCodeDialog',
  props: {
    visible: Boolean,
    customer: Object
  },
  data() {
    return {
      defaultAvatar
    }
  },
  computed: {
    isQrCodeExpired() {
      if (!this.customer.qrCodeExpireAt) return true;
      const now = new Date();
      const expireAt = new Date(this.customer.qrCodeExpireAt);
      return now > expireAt;
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    },
    
    downloadQrCode() {
      if (!this.customer.qrCodePath) {
        this.$message.warning('没有可下载的二维码');
        return;
      }
      
      if (this.isQrCodeExpired) {
        this.$message.warning('二维码已过期，请重新生成');
        return;
      }
      
      const link = document.createElement('a');
      link.href = this.customer.qrCodePath;
      link.setAttribute('download', `客户_${this.customer.name}_二维码.png`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    
    refreshQrCode() {
      this.$emit('refresh', this.customer.id);
    }
  }
}
</script>

<style scoped>
.qr-dialog-content {
  text-align: center;
}

.qr-header {
  margin-bottom: 20px;
}

.qr-header .customer-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.qr-header h4 {
  margin: 0;
  font-size: 18px;
}

.qr-header p {
  margin: 5px 0 0;
  color: #909399;
  font-size: 14px;
}

.qr-code-container {
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
  display: inline-block;
  margin: 15px 0;
}

.qr-code-placeholder {
  width: 250px;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 8px;
  border: 1px dashed #dcdfe6;
}

.qr-text {
  margin-top: 15px;
  color: #606266;
  font-weight: 500;
}

.qr-footer {
  margin-top: 20px;
}

.qr-footer p {
  color: #909399;
  margin-bottom: 15px;
}

.qr-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.qr-code-image {
  width: 250px;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  margin: 0 auto;
}

.image-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
}

.image-error i {
  font-size: 24px;
  margin-bottom: 5px;
}

.qr-expired-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.expired-text {
  color: white;
  font-weight: bold;
  font-size: 18px;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.8);
}
</style>